import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'
import tokens from '@lacedltd/design-tokens'
import { mediaQuery } from '@lacedltd/laced-components'

const marqueeLeft = keyframes({
  from: { transform: 'translate3d(0, 0, 0)' },
  to: { transform: 'translate3d(-50%, 0, 0)' }
})

const marqueeRight = keyframes({
  from: { transform: 'translate3d(-50%, 0, 0)' },
  to: { transform: 'translate3d(0, 0, 0)' }
})

export const PopularNowWrapper = styled.div({
  paddingTop: tokens.spacing[9],
  position: 'relative',

  [mediaQuery.m.min]: {
    paddingTop: tokens.spacing[10]
  }
})

export const SectionHeader = styled.div({
  display: 'flex',
  alignItems: 'center',
  marginBottom: tokens.spacing[6],

  [mediaQuery.m.min]: {
    marginBottom: tokens.spacing[7]
  }
})

export const SectionTitle = styled.h3({
  fontFamily: tokens.fontFamilies.primary,
  fontSize: tokens.fontSize[4],
  fontWeight: 400,
  textTransform: 'uppercase',
  color: tokens.color.airJordan.p,
  lineHeight: 1,
  margin: 0
})

export const MarqueeArea = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
  gap: `${tokens.spacing[2]} ${tokens.spacing[5]}`,

  [mediaQuery.m.min]: {
    gap: `${tokens.spacing[3]} ${tokens.spacing[6]}`
  },

  '@media (prefers-reduced-motion: no-preference)': {
    flexWrap: 'nowrap',
    flexDirection: 'column',
    gap: tokens.spacing[4],

    [mediaQuery.m.min]: {
      gap: tokens.spacing[6]
    }
  }
})

export const MarqueeRow = styled.div({
  display: 'contents',

  '@media (prefers-reduced-motion: no-preference)': {
    display: 'block',
    overflow: 'hidden',
    WebkitMaskImage:
      'linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)',
    maskImage:
      'linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)'
  }
})

export const MarqueeTrack = styled.div<{ direction: 'left' | 'right' }>(
  ({ direction }) => ({
    display: 'contents',

    '@media (prefers-reduced-motion: no-preference)': {
      display: 'inline-flex',
      alignItems: 'center',
      gap: tokens.spacing[5],
      whiteSpace: 'nowrap',
      willChange: 'transform',

      [mediaQuery.m.min]: {
        gap: tokens.spacing[6]
      },

      animation: `${direction === 'left' ? marqueeLeft : marqueeRight} ${
        direction === 'left' ? '60s' : '70s'
      } linear infinite`,

      '&:hover': {
        animationPlayState: 'paused'
      }
    }
  })
)

export const DuplicateSet = styled.span({
  display: 'none',

  '@media (prefers-reduced-motion: no-preference)': {
    display: 'contents'
  }
})

export const PopularNowLink = styled.a({
  display: 'inline-flex',
  alignItems: 'center',
  whiteSpace: 'nowrap',
  flexShrink: 0,
  minHeight: 44,
  padding: `${tokens.spacing[2]} 0`,
  background: 'transparent',
  color: tokens.color.airJordan.p,
  fontSize: tokens.fontSize[1],
  fontFamily: tokens.fontFamilies.primary,
  letterSpacing: '0.02em',
  textDecoration: 'none',
  position: 'relative',
  cursor: 'pointer',
  transition: 'opacity 0.3s ease',

  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: 8,
    left: 0,
    width: '100%',
    height: 1,
    background: tokens.color.airJordan.p,
    transformOrigin: 'left',
    transform: 'scaleX(0)',
    transition: 'transform 0.3s ease'
  },

  '&:hover': {
    '&::after': {
      transform: 'scaleX(1)'
    }
  },

  '&:active': {
    opacity: 0.6
  }
})
